import Chip from '@material-ui/core/Chip';
import React from 'react';
import {DigiknowOrgType} from '../../ext/lib/types';
import {useTheme, makeStyles} from '@material-ui/core';
import * as R from 'ramda';

type IStatusableAd = {
  organizationType: DigiknowOrgType,
  paidAt?: string,
  approvedAt?: string,
  programmedAt?: string
};

const AdStatusChip: React.FC<{ad: IStatusableAd}> = ({ad}) => {
  type AdStatus = 'Unpaid'|'Paid'|'Approved'|'Programmed';

  const theme = useTheme();

  const useStyles = makeStyles({
    goBadge: {
      background: theme.palette.success.main,
      color: theme.palette.success.contrastText,
      width: '7rem'
    },
    readyBadge: {
      background: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      width: '7rem'
    },
    paidBadge: {
      background: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      width: '7rem'
    },
    unpaidBadge: {
      background: theme.palette.error.main,
      color: theme.palette.error.contrastText,
      width: '7rem'
    }
  });
  const classes = useStyles();

  function propIsSet(propName: string): (_: IStatusableAd) => boolean {
    return R.propSatisfies(R.complement(R.isNil), propName);
  }

  const status = R.cond([
    [propIsSet('programmedAt'),
      R.always('Programmed')],
    [propIsSet('approvedAt'),
      R.always('Approved')],
    [R.either(propIsSet('paidAt'), R.propEq('organizationType', 'Housing/Residential Dining' as DigiknowOrgType)),
      R.always('Paid')],
    [R.T,
      R.always('Unpaid')]
  ]) as (_: IStatusableAd) => AdStatus;

  const className = {
    Unpaid: classes.unpaidBadge,
    Paid: classes.paidBadge,
    Approved: classes.readyBadge,
    Programmed: classes.goBadge
  };

  return <Chip
    className={className[status(ad)]}
    label={status(ad)}
  />;
};
export default AdStatusChip;
